import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

class SettingsController extends Controller
{
  @service session;

  get currentUser() {
    return this.session.currentUser;
  }

  get taxesEnabled() {
    return !!this.session.currentUser?.userExperiments?.find(userExperiment => userExperiment.name === 'taxes')?.enabled;
  }

  /**
   * Set this to false if you would like to NOT show the legacy settings frame.
   *
   * @param {Boolean}
   */
  @tracked isUsingLegacySettingsFrame = true;

  /** @type {boolean} */
  @tracked newSettingsPage = false;
}

export default SettingsController;
